define('views/components/manual_payment/manual_payment',['require','backbone','text!templates/components/manual_payment/manual_payment.html'],function(require){

    var Backbone = require('backbone');

    var temp = require("text!templates/components/manual_payment/manual_payment.html");
    return Backbone.Marionette.ItemView.extend({
        tagName: 'tr',
        template: _.template(temp),
        className: 'payment-item',

        initialize: function () {
            if (this.model.get('transaction_status') === 0) {
                this.$el.addClass('bg-success-light');
            }
        }
    });
});
